import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalSettings } from "./constants";
import type { ConversationalSettingsResult } from "./types";
import { isConversationalSettingsResult } from "./validators";

export const getConversationalSettings = reactQueryFetcherAdapter(
  conversationalSettings,
  (signal: AbortSignal, appGroupId: string): Promise<ConversationalSettingsResult> => {
    return fetch(`/${appGroupId}/conversational/settings`, "GET", {}, { signal });
  },
  isConversationalSettingsResult
);
